var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.00383 8.41805C6.6133 8.02752 6.61331 7.39435 7.00383 7.00383C7.39435 6.61331 8.02752 6.61331 8.41804 7.00383L11.0057 9.59149L13.5907 7.00645C13.9813 6.61593 14.6144 6.61593 15.0049 7.00645C15.3955 7.39698 15.3955 8.03014 15.0049 8.42067L12.4199 11.0057L15.0039 13.5896C15.3944 13.9802 15.3944 14.6133 15.0039 15.0038C14.6133 15.3944 13.9802 15.3944 13.5896 15.0038L11.0057 12.4199L8.42094 15.0047C8.03042 15.3952 7.39725 15.3952 7.00673 15.0047C6.61621 14.6141 6.61621 13.981 7.00673 13.5904L9.59147 11.0057L7.00383 8.41805Z",
    fill: "#D63333"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22 11C22 17.0751 17.0751 22 11 22C4.92487 22 0 17.0751 0 11C0 4.92487 4.92487 0 11 0C17.0751 0 22 4.92487 22 11ZM2.00683 11C2.00683 15.9668 6.03321 19.9932 11 19.9932C15.9668 19.9932 19.9932 15.9668 19.9932 11C19.9932 6.03321 15.9668 2.00683 11 2.00683C6.03321 2.00683 2.00683 6.03321 2.00683 11Z",
    fill: "#D63333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIcon);
export default __webpack_public_path__ + "static/media/close_icon.40eff4c16a8855bb8ece1b141a038d28.svg";
export { ForwardRef as ReactComponent };